<script lang="ts">
  import * as Popover from "$lib/components/ui/popover";
  import { buttonVariants } from '@/lib/components/ui/button';
  import { cn } from '@/lib/utils';

  export let message: string = null;
  export let icon: string = "fa-regular fa-circle-question";
  export let iconClass: string = "text-gray-500";
  export let label: string = "More information";
</script>

<Popover.Root portal="#shadcn-ui-dialog-target">
  <Popover.Trigger class={cn(buttonVariants({ variant: "ghost", size: 'icon' }), 'rounded-full w-7 h-7', iconClass)} aria-label={label}>
    <i class={icon}/>
  </Popover.Trigger>
  <Popover.Content side='top' class="w-[300px] min-w-0 text-gray-600">
    {#if message}
      <p class='text-sm message-body'>
        {@html message}
      </p>
    {/if}
    <slot />
  </Popover.Content>
</Popover.Root>

<style>
  .message-body :global(a) {
    color: #2f7076;
    text-decoration: underline;
  }
</style>
